<template>
    <div class="card mt-3">
        <div class="card-header">
            Reimbursement Settings
        </div>
        <div class="card-body">
            <div class="row m-2">
                <div class="form-group col-md-12">
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input" type="checkbox" id="use_hospital_reimbursement_schedule" name="use_hospital_reimbursement_schedule" :checked="isChecked" v-model="isChecked" @change="toggle($event)">
                        <label class="custom-control-label" for="use_hospital_reimbursement_schedule">Use Hospital Reimbursement Schedule</label>
                    </div>                     
                </div>
            </div>
            <div class="row m-2">
                <div class="form-group col-md-12">
                    <div class="container-fluid">
                        <div class="row">
                            <div :class="['col-sm-6 text-nowrap', {'text-muted': !isChecked}]">Standard Metropolitan Statistical Area</div>
                            <div :class="['col-sm-3 text-nowrap text-right', {'text-muted': !isChecked}]">Medical Per Diem</div>
                            <div :class="['col-sm-3 text-nowrap text-right', {'text-muted': !isChecked}]">Surgical Per Diem</div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <select class="custom-select" id="per_diem_rate_id" name="per_diem_rate_id" v-model="rate" :disabled="!isChecked">
                                    <option value="">N/A</option>
                                    <option v-for="rate in options" :key="'per-diem-rate-' + rate.id" :value="rate.id">{{ rate.standard_metropolitan_statistical_area }}</option>
                                </select>
                            </div>
                            <div :class="['col-sm-3 text-right', {'text-muted': !isChecked}]">{{ medicalRate }}</div>
                            <div :class="['col-sm-3 text-right', {'text-muted': !isChecked}]">{{ surgicalRate }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    props: ['checked', 'options', 'value'],
    data() { 
        return { 
            isChecked: this.checked,
            rate: this.value ?? '' 
        } 
    },
    computed: {
        medicalRate: function () { return this.rate ? this.options.find(x => x.id == this.rate).medical_per_diem : 'N/A'; },
        surgicalRate: function () { return this.rate ? this.options.find(x => x.id == this.rate).surgical_per_diem : 'N/A'; }
    },
    methods: {
        toggle: function (e) {
            this.$nextTick(() => { 
                this.rate = '';
            });
        }
    } 
}
</script>